export const STRINGS = {
    FIND_LOCATION_LABEL: 'Book an appointment ',
    FIND_LOCATION_PLACEHOLDER: 'Search by address, city or postal code',
    ERROR_MINIMUM_STRING:
        'Please enter a minimum of 3 characters in the search bar to get valid results.',
    FIND_LOCATION_BTN: 'Find a Location',
    USE_MY_LOCN: 'Use My location',
    SEARCH_RESULTS: 'Search Results',
    SORT: 'Sort',
    SORT_OPTIONS: [
        { value: 'CLOSEST', label: 'Closest to me' },
        { value: 'EARLIEST', label: 'Earliest appointment' },
        { value: 'SHORTEST', label: 'Shortest walk-in wait time' },
    ],
    SPECIALITY_TESTS: 'Specialty Tests',
    TOLERANCE_TEST: 'Tolerance Tests',
    APPOINTMENTBOOKINGS_BOOKINGSUCCESS_ADDTOCALENDER: 'Add to Calendar',
    WAIT_TIME: ' min walk-in wait time',
    FIND_LOCATION_PLACEHOLDER_MOBILE: 'Search by address'
}

export const PRINT_CONSTANTS = {
    PRINT_SETTINGS: "width=800,height=600,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no,addressbar=no",
    PRINT_HEADER: `<!DOCTYPE html><html>
		<head>
			<style>
					.noPrint{ display:none } 
			       .print{
					 display:block
					}
				</style>
				</head>
				<body onload="window.print();">
				<div class="alert-info">`,
    PRINT_FOOTER: '</div></body></html>'
}

export const PRINT_APPOINTMENT_PDF = {
    PRINT_SETTINGS: "width=800,height=800,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=LifeLabs Appointment Confirmation PDF,addressbar=LifeLabs Appointment Confirmation PDF",
    PRINT_HEADER: `<!DOCTYPE html><html>
		<head>
			<title>LifeLabs</title>
			<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
			<meta name="viewport" content="width=device-width, initial-scale=1">
			<meta http-equiv="X-UA-Compatible" content="IE=edge" />
			<style type="text/css">
					/* CLIENT-SPECIFIC STYLES */
					body, table, td, a { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
					table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
					img { -ms-interpolation-mode: bicubic; }

					/* RESET STYLES */
					img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; }
					table { border-collapse: collapse !important; }
					body { height: 100% !important; margin: 0 !important; padding: 0 !important; width: 100% !important; }

					/* iOS BLUE LINKS */
					a[x-apple-data-detectors] {
						color: inherit !important;
						text-decoration: none !important;
						font-size: inherit !important;
						font-family: inherit !important;
						font-weight: inherit !important;
						line-height: inherit !important;
					}

					/* MEDIA QUERIES */
					@media screen and (max-width: 480px) {
						.mobile-hide {
							display: none !important;
						}
						.mobile-center {
							text-align: center !important;
						}
					}

					/* ANDROID CENTER FIX */
					div[style*="margin: 16px 0;"] { margin: 0 !important; }

				   .noPrint{ display:none }
			       .print{
					 display:block
					}

                    @media print {
                        body {-webkit-print-color-adjust: exact;}
                    }
                    /* Optional: Make the printed content occupy the full window */
                    body, html {
                        margin: 0;
                        padding: 0;
                        width: 100%;
                        height: 100%;
                    }
                    .alert-info {
                        width: 100%;
                        height: 100%;
                    }
			</style>
		</head>
		<body style="margin: 0 !important; padding: 0 !important; background-color: #FFFFFF;" bgcolor="#FFFFFF" onload="window.print();">
			<div class="alert-info">
			<table border="0" cellpadding="0" cellspacing="0" width="100%">
    			<tr>
				<td align="center" style="background-color: #FFFFFF;" bgcolor="#FFFFFF">
				<!--[if (gte mso 9)|(IE)]>
				<table align="center" border="0" cellspacing="0" cellpadding="0" width="700">
				<tr>
				<td align="center" valign="top" width="700">
				<![endif]-->
        	<table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:700px;">
            	<tr>
                <td align="center" valign="top" style="font-size:0; padding: 20px;" bgcolor="#13499f">
                <!--[if (gte mso 9)|(IE)]>
                <table align="center" border="0" cellspacing="0" cellpadding="0" width="700">
                <tr>
                <td align="left" valign="top" width="300">
                <![endif]-->
                <div style="display:inline-block; max-width:50%; min-width:100px; vertical-align:top; width:100%;">
                    <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px;">
                        <tr>
                            <td align="left" valign="top"  class="mobile-center">
                               <span class="fullCenter"><img width="160" src="data:image/png;base64,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" editable="true" alt="" border="0" mc:edit="1"></span>
                            </td>
                        </tr>
                    </table>
                </div>
                <!--[if (gte mso 9)|(IE)]>
                </td>
                <td align="right" width="300">
                <![endif]-->
                <div style="display:inline-block; max-width:50%; min-width:100px; vertical-align:top; width:100%;" class="mobile-hide"></div>
                <!--[if (gte mso 9)|(IE)]>
                </td>
                </tr>
                </table>
                <![endif]-->
                </td>
            </tr>
            <tr>
                <td align="center" style="padding: 20px; background-color: #ffffff;" bgcolor="#ffffff">
                <!--[if (gte mso 9)|(IE)]>
                <table align="center" border="0" cellspacing="0" cellpadding="0" width="700">
                <tr>
                <td align="center" valign="top" width="700">
                <![endif]-->
                <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:700px;">
                    <tr>
                        <td align="left" style="font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 400; line-height: 24px;">

                            <span style="font-size: 16px; font-weight: 400; line-height: 24px; color: #000000;">Hi @{variables('Display Name')}, <br />
                              <br />
								Thanks so much for choosing LifeLabs! This email is to confirm your upcoming appointment:<br />
								<br />
								<strong>@{outputs('Compose_Display_Date')}<br />
								</strong>@{variables('Display Address')} <br />
								@{variables('Test Name')}  – at least @{variables('Test Duration')} mins<br>
								<br />
								Confirmation Number – <strong>@{triggerOutputs()?['body/csap_bookingconfirmationnumber']}</strong><br>
								<br>
								When  you arrive, please wait in the designated area to inform one of our team  members that you have an appointment. We look forward to seeing you on your  next visit!</span>
                        </td>
                    </tr>
                  </table>
                <!--[if (gte mso 9)|(IE)]>
                </td>
                </tr>
                </table>
                <![endif]-->
                </td>
            </tr>

            <tr>
                <td align="center" style="padding: 20px; background-color: #ffffff;" bgcolor="#ffffff">
                <!--[if (gte mso 9)|(IE)]>
                <table align="center" border="0" cellspacing="0" cellpadding="0" width="700">
                <tr>
                <td align="center" valign="top" width="700">
                <![endif]-->
                <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:700px;">
                    <tr>
                   <td align="left" style="font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 400; line-height: 24px;">

                          <strong>What to Expect </strong><br>
                              To learn more about what to expect during this appointment, <a href="https://www.lifelabs.com/patients/what-to-expect/" target="_blank">visit our what to expect information page</a>. <br>
  <br>
                              If you require assistance, please call toll-free 1-877-849-3637 (Ontario), 1-800-431-7206 (British Columbia) or 1-888-333-0222 (Saskatchewan). <br><br>

					    <strong>Test Preparation</strong><br>
                          Some tests require special preparation, please <a href="https://www.lifelabs.com/patients/preparing-for-a-test/patient-test-instructions/" target="_blank">review these instructions to prepare for the appointment</a>.<br>
  <br>
  <strong>
    Please bring the following items to the appointment: </strong>
                            <ul>
                              <li>Provincial health card (if applicable) <br />
                              </li>
                              <li>Completed requisition form, including <br />
                                <ul>
                                  <li>Physician signature <br />
                                  </li>
                                  <li>All required information (First and last name, health card number, date of birth, phone number, and address) <br />
                                  </li>
                                </ul>
                              </li>
                              <li>Other supporting forms (if applicable) </li>
                              <li>A form of payment (if applicable, we accept Interac, Mastercard, and Visa)<br />
                                <br />
                              </li>
                            </ul>
                            <strong>View Results </strong><br>
If you are not currently registered to view results online, make sure to ask the lab technician for the Lab Visit Number (LVN) during the appointment. This LVN will be required to complete the Results Registration process on <a href="https://mycarecompass.lifelabs.com/" target="_blank">MyCareCompass</a> after the appointment. <br>

<br>
Thank you for choosing LifeLabs! <br>

<br>
The LifeLabs Patient Service Centre Team <br>
<br>
<img src="data:image/png;base64,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" width="150" alt="LifeLabs" align="center"/>
<br><br><br>
                        </td>
                    </tr>
                   <tr>
                        <td align="center">         <span class="fullCenter" style="text-align: center; font-family: Helvetica, Arial, sans-serif, 'Open Sans'; font-size: 12px; color: #000000; line-height: 18px; font-weight: 400;">This email address is unmonitored, please do not reply to this email address.<br>
                            <br>
                           This email was sent to <a href="mailto:@{variables('Recipient Email')}">@{variables('Recipient Email')}</a> because you recently booked an appointment at a LifeLabs location. <br>

                          If you no longer wish to receive email notifications with regards to your appointment, please <a href="https://mycarecompass.lifelabs.com/" target="_blank">log in to MyCareCompass</a>, go to My Account > Account Settings > Change Consent to be Contacted and update your preference.<br>
<br>
<br>
<strong>LifeLabs</strong><br />
100 International Blvd,Toronto, ON, M9W 6J6</span>
							<br>
                        </td>
                    </tr>
                </table>
                <!--[if (gte mso 9)|(IE)]>
                </td>
                </tr>
                </table>
                <![endif]-->
                </td>
            </tr>
        </table>
        <!--[if (gte mso 9)|(IE)]>
        </td>
        </tr>
        </table>
        <![endif]-->
        </td>
    </tr>
</table>

</body>
</html>`
    ,
    PRINT_FOOTER: '</div></body></html>'
}

export const CONFIRMATION_EMAIL = `
<html>
<head>
<title>LifeLabs</title>
<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1">
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<style type="text/css">
/* CLIENT-SPECIFIC STYLES */
body, table, td, a { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
img { -ms-interpolation-mode: bicubic; }

/* RESET STYLES */
img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; }
table { border-collapse: collapse !important; }
body { height: 100% !important; margin: 0 !important; padding: 0 !important; width: 100% !important; }

/* iOS BLUE LINKS */
a[x-apple-data-detectors] {
    color: inherit !important;
    text-decoration: none !important;
    font-size: inherit !important;
    font-family: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important;
}

/* MEDIA QUERIES */
@media screen and (max-width: 480px) {
    .mobile-hide {
        display: none !important;
    }
    .mobile-center {
        text-align: center !important;
    }
}

/* ANDROID CENTER FIX */
div[style*="margin: 16px 0;"] { margin: 0 !important; }
</style>
</head>
<body style="margin: 0 !important; padding: 0 !important; background-color: #FFFFFF;" bgcolor="#FFFFFF">


<table border="0" cellpadding="0" cellspacing="0" width="100%">
    <tr>
        <td align="center" style="background-color: #FFFFFF;" bgcolor="#FFFFFF">
        <!--[if (gte mso 9)|(IE)]>
        <table align="center" border="0" cellspacing="0" cellpadding="0" width="700">
        <tr>
        <td align="center" valign="top" width="700">
        <![endif]-->
        <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:700px;">
            <tr>
                <td align="center" valign="top" style="font-size:0; padding: 20px;" bgcolor="#13499f">
                <!--[if (gte mso 9)|(IE)]>
                <table align="center" border="0" cellspacing="0" cellpadding="0" width="700">
                <tr>
                <td align="left" valign="top" width="300">
                <![endif]-->
                <div style="display:inline-block; max-width:50%; min-width:100px; vertical-align:top; width:100%;">
                    <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px;">
                        <tr>
                            <td align="left" valign="top"  class="mobile-center">
                               <span class="fullCenter"><img width="160" src="https://go.lifelabs.com/l/476242/2024-03-06/33b34n/476242/1709741532ekGVSZqz/LifeLabs_logo_rgb_white.png" editable="true" alt="" border="0" mc:edit="1"></span>
                            </td>
                        </tr>
                    </table>
                </div>
                <!--[if (gte mso 9)|(IE)]>
                </td>
                <td align="right" width="300">
                <![endif]-->
                <div style="display:inline-block; max-width:50%; min-width:100px; vertical-align:top; width:100%;" class="mobile-hide"></div>
                <!--[if (gte mso 9)|(IE)]>
                </td>
                </tr>
                </table>
                <![endif]-->
                </td>
            </tr>
            <tr>
                <td align="center" style="padding: 20px; background-color: #ffffff;" bgcolor="#ffffff">
                <!--[if (gte mso 9)|(IE)]>
                <table align="center" border="0" cellspacing="0" cellpadding="0" width="700">
                <tr>
                <td align="center" valign="top" width="700">
                <![endif]-->
                <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:700px;">
                    <tr>
                        <td align="left" style="font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 400; line-height: 24px;">
                          
                            <span style="font-size: 16px; font-weight: 400; line-height: 24px; color: #000000;">Hi @{variables('Display Name')}, <br />
                              <br />
Thanks so much for choosing LifeLabs! This email is to confirm your upcoming appointment:<br />
<br />
<strong>@{outputs('Compose_Display_Date')}<br />
</strong>@{variables('Display Address')} <br />
@{variables('Test Name')}  – at least @{variables('Test Duration')} mins<br>
<br />
Confirmation Number – <strong>@{triggerOutputs()?['body/csap_bookingconfirmationnumber']}</strong><br>
<br>
When  you arrive, please wait in the designated area to inform one of our team  members that you have an appointment. We look forward to seeing you on your  next visit!</span>
                        </td>
                    </tr>
                  </table>
                <!--[if (gte mso 9)|(IE)]>
                </td>
                </tr>
                </table>
                <![endif]-->
                </td>
            </tr>
         
            <tr>
                <td align="center" style="padding: 10px; background-color: #ffffff;" bgcolor="#ffffff" height="100%" valign="top" width="100%">
                <!--[if (gte mso 9)|(IE)]>
                <table align="center" border="0" cellspacing="0" cellpadding="0" width="700">
                <tr>
                <td align="center" valign="top" width="700">
                <![endif]-->
                <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px;">
                    <tr>
                        <td align="center" valign="top" style="font-size:0;">

                            <!--[if (gte mso 9)|(IE)]>
                            <table align="center" border="0" cellspacing="0" cellpadding="0" width="600">
                            <tr>
                            <td align="left" valign="top" width="190">
                            <![endif]-->
                            <div style="display:inline-block; max-width:33.3333%; min-width:200px; vertical-align:top; width:100%;">

                                <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:200px;">
                                  <tr>
                                        <td align="center" valign="top" style="font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 400; line-height: 24px; padding-bottom: 15px;"><a href="@{outputs('Get_Location_by_ID')?['body/csap_mapaddress']}"><img src="https://go.lifelabs.com/l/476242/2024-04-05/33fkpj/476242/17123497446TBWgov4/directions_button_MCC_email.png" width="190" height="41" alt="Directions" style="display: block; border: 0px;"/></a></td>
                                    </tr>
                                </table>
                            </div>
                            <!--[if (gte mso 9)|(IE)]>
                            </td>
                            <td width="10" style="font-size: 1px;">&nbsp;</td>
                            <td align="left" valign="top" width="190">
                            <![endif]-->
                            <div style="display:inline-block; max-width:33.3333%; min-width:200px; vertical-align:top; width:100%;">
                                <table align="right" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:200px; float: right;">
                                    <tr>
                                        <td align="center" valign="top" style="font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 400; line-height: 24px; padding-bottom: 15px;"><a href="@{parameters('ReactPortal URL (csap_ReactPortalURL)')}?source=cancel&activityId=%3C@{triggerOutputs()?['body/activityid']}%3E&customerId=%3C@{triggerBody()?['customerId']}%3E"><img src="https://go.lifelabs.com/l/476242/2024-04-05/33fkpq/476242/1712350112vZojklCu/cancel_apt_button_MCC_email.png" width="190" height="41" alt="Cancel Appointment" style="display: block; border: 0px;"/></a>
                                           

                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <!--[if (gte mso 9)|(IE)]>
                            </td>
                            </tr>
                            </table>
                            <![endif]-->
                        </td>
                    </tr>
                </table>
                <!--[if (gte mso 9)|(IE)]>
                </td>
                </tr>
                </table>
                <![endif]-->
                </td>
            </tr>
            <tr>
                <td align="center" style="padding: 20px; background-color: #ffffff;" bgcolor="#ffffff">
                <!--[if (gte mso 9)|(IE)]>
                <table align="center" border="0" cellspacing="0" cellpadding="0" width="700">
                <tr>
                <td align="center" valign="top" width="700">
                <![endif]-->
                <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:700px;">
                    <tr>
                   <td align="left" style="font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 400; line-height: 24px;">
                          
                          <strong>What to Expect </strong><br>
                              To learn more about what to expect during this appointment, <a href="https://www.lifelabs.com/patients/what-to-expect/" target="_blank">visit our what to expect information page</a>. <br>
  <br>
                              If you require assistance, please call toll-free 1-877-849-3637 (Ontario), 1-800-431-7206 (British Columbia) or 1-888-333-0222 (Saskatchewan). <br><br>
                       
                        <strong>Test Preparation</strong><br>
                          Some tests require special preparation, please <a href="https://www.lifelabs.com/patients/preparing-for-a-test/patient-test-instructions/" target="_blank">review these instructions to prepare for the appointment</a>.<br>
  <br>
  <strong>
    Please bring the following items to the appointment: </strong>
                            <ul>
                              <li>Provincial health card (if applicable) <br />
                              </li>
                              <li>Completed requisition form, including <br />
                                <ul>
                                  <li>Physician signature <br />
                                  </li>
                                  <li>All required information (First and last name, health card number, date of birth, phone number, and address) <br />
                                  </li>
                                </ul>
                              </li>
                              <li>Other supporting forms (if applicable) </li>
                              <li>A form of payment (if applicable, we accept Interac, Mastercard, and Visa)<br />
                                <br />
                              </li>
                            </ul>
                            <strong>View Results </strong><br>
If you are not currently registered to view results online, make sure to ask the lab technician for the Lab Visit Number (LVN) during the appointment. This LVN will be required to complete the Results Registration process on <a href="https://mycarecompass.lifelabs.com/" target="_blank">MyCareCompass</a> after the appointment. <br>

<br>
Thank you for choosing LifeLabs! <br>

<br>
The LifeLabs Patient Service Centre Team <br>
<br>
<img src="https://go.lifelabs.com/l/476242/2024-03-06/33b37c/476242/1709741703oTRCikmy/LifeLabs_logo_rgb.png" width="150" alt="LifeLabs" align="center"/>
<br><br><br>
                        </td>
                    </tr>
                   <tr>
                        <td align="center">         <span class="fullCenter" style="text-align: center; font-family: Helvetica, Arial, sans-serif, 'Open Sans'; font-size: 12px; color: #000000; line-height: 18px; font-weight: 400;">This email address is unmonitored, please do not reply to this email address.<br>
                            <br>
                           This email was sent to <a href="mailto:@{variables('Recipient Email')}">@{variables('Recipient Email')}</a> because you recently booked an appointment at a LifeLabs location. <br>

                          If you no longer wish to receive email notifications with regards to your appointment, please <a href="https://mycarecompass.lifelabs.com/" target="_blank">log in to MyCareCompass</a>, go to My Account > Account Settings > Change Consent to be Contacted and update your preference.<br>
<br>
<br>
<strong>LifeLabs</strong><br />
100 International Blvd,Toronto, ON, M9W 6J6</span>
                            <br>
                        </td>
                    </tr>
                </table>
                <!--[if (gte mso 9)|(IE)]>
                </td>
                </tr>
                </table>
                <![endif]-->
                </td>
            </tr>
        </table>
        <!--[if (gte mso 9)|(IE)]>
        </td>
        </tr>
        </table>
        <![endif]-->
        </td>
    </tr>
</table>
   
</body>
</html>
`
